import { Item } from '../../formula/components/item'
import type { ItemProps } from '../../formula/types'

/**
 * Renders a dash separator between the min and max values in a spread widget.
 */
export function Separator(props: Omit<ItemProps, 'children'>) {
  return <Item {...props}>-</Item>
}
